import React from 'react';
import { Container } from 'react-bootstrap';
import { motion } from 'framer-motion';
import RoomsGrid from '../RoomsGrid';
import StatsSection from '../StatsSection';
import AmenitiesSection from '../AmenitiesSection';
import NestedPageHero from '../NestedPageHero';
import '../../style/Rooms.css';

export default function RoomsLayout() {
    return (
        <div id='rooms'>
            <NestedPageHero title={'Rooms'} />

            <Container className="py-5">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    <h2 className="text-center mb-5 text-primary fw-bolder fs-2">OUR Rooms</h2>

                    {/* Rooms Grid */}
                    <RoomsGrid />


                </motion.div>
            </Container>
            {/* Stats Section */}
            <div className="py-5 pt-0">
                <StatsSection />
            </div>
            <Container>

                {/* Amenities Section */}
                <div className="py-5">
                    <h3 className="text-center mb-4">The colorful castle</h3>
                    <AmenitiesSection />
                </div>
            </Container>
        </div>
    );
}
